<div class="handpick-brands">
  @if (!isBrandRating) {
    <p class="section-heading">Shop By Category</p>
  }
  @if (isBrandRating) {
    <div class="title">Order Now</div>
  }
  @if (isLoading) {
    <div class="membership-category-wrapper">
      <ng-container>
        @for (category of loadingCategories; track category) {
          <div class="membership-category">
            <img src="{{DEPLOY_URL}}/assets/images/missing.png" appDeferImageLoad>
          </div>
        }
      </ng-container>
    </div>
  }

  @if (!isLoading) {
    <div>
      <!-- Layout-1 -->
      @if (isThreeTileLayout) {
        @for (category of primaryBrandCategories | categoryFilter: brandId; track category) {
          <div>
            @if (category.shape === 'square') {
              <div>
                <div data-test="landing-page-category" (click)="showMenuClick(category)" class="halfWidth">
                  <img class="category-image" [alt]="category.description" appDeferImageLoad
                    [imageSrc]="category.image" />
                </div>
              </div>
            }
            @if (category.shape === 'rectangle') {
              <div>
                <div data-test="landing-page-category" (click)="showMenuClick(category)" class="fullWidth">
                  <img class="category-image" [alt]="category.description" appDeferImageLoad
                    [imageSrc]="category.image" />
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div class="membership-category-wrapper">
          @for (category of primaryBrandCategories | categoryFilter: brandId; track category) {
            <div data-test="landing-page-category" class="membership-category" (click)="showMenuClick(category)"
              >
              <img src="{{DEPLOY_URL}}/assets/images/missing.png" [imageSrc]="category.image" appDeferImageLoad
                [alt]="category.description">
            </div>
          }
        </div>
      }
      <!-- Layout-2 -->
    </div>
  }
</div>

<div class="clearfix"></div>
<div class="space-30"></div>